import React, { FC } from 'react';
import { useTranslation } from '@shared/core';
import { getTravelDistance } from '@shared/utils/distanceInMiles';
import { BoxProps, Flex, TextV2 } from '@withjoy/joykit';
import { WalkIcon } from '@assets/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { Car } from '@withjoy/joykit/icons';

interface DistanceStatisticsProps extends BoxProps {
  milesToVenue?: number | null;
  useShortWording?: boolean;
}

export const DistanceStatistics: FC<DistanceStatisticsProps> = ({ milesToVenue, useShortWording = false, ...props }) => {
  const { t } = useTranslation('guestSiteCustom');
  const accTrans = t('accommodations');

  if (!milesToVenue) {
    return null;
  }

  const travelDistance = getTravelDistance(milesToVenue);

  if (travelDistance.minutes <= 0) {
    return null;
  }

  const transWalk = useShortWording ? accTrans.min : accTrans.minWalk;
  const transDrive = useShortWording ? accTrans.min : accTrans.minDrive;
  const travelDistanceLabel = travelDistance.isWalkableDistance ? transWalk({ min: travelDistance.minutes }) : transDrive({ min: travelDistance.minutes });

  return (
    <Flex
      width="fit-content"
      alignItems="center"
      {...props}
    >
      {travelDistance?.isWalkableDistance ? (
        <WalkIcon color="mono14" />
      ) : (
        <Car
          size={16}
          color="mono14"
        />
      )}
      <TextV2
        typographyVariant="body1"
        color="mono14"
        lineHeight={1.5}
        marginLeft={1}
        fontSize={props.fontSize ?? 14}
        maxWidth={{ _: pxToRem(180), sm: pxToRem(260) }}
        truncate
      >
        {travelDistanceLabel}
      </TextV2>
    </Flex>
  );
};
